export default "<div class=\"parc\">\n    {{ParcInComponent}}\n</div>\n";